import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import { hideModalBokecc, setTitleBar, showModalBokecc } from '../../../../../actions/ui'

import { connect } from 'react-redux'
import isElectron from 'is-electron'
import { getFields as getFieldsToShow, processAsPlaylist, processAsResource } from "../../../../../../web/Utils/utils";
import { useQuery } from "@apollo/client";
import { FAVORITES_QUERY } from "./Query/favoritesQuery";
import Loader from "../../../Loader/Loader";
import { Black, Shadow, WerfenColor } from "../../../../Constants/ColorChart";
import ResultTable from "../../../ResultTable/ResultTable";
import Dialog from "../../../Dialog/Dialog";
import { Modal } from "react-bootstrap";

let electron;

if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

//-.-.-.-.-.-.-.-.-.-.FINISH ELECTRON IMPORT CODE.-.-.-.-.-.-.-.-.-.-.-

/*
 *  @Description:   Component that renders a table all favorites items.
 */

const StyledDiv = styled.div`
  width: calc(94% - 60px);
  margin-right: auto;
  margin-left: 80px;
  @media screen and (min-width: 992px){
    margin-left: 280px; 
    width: calc(94% - 250px);
  }
`;

const StyledModalBody = styled.div`
    height: 0px;
    padding-bottom: 50%;
    iframe {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;

const FavoritesSection = ( props ) => {
    const [ downloadedIds, setDownloadedIds ] = useState ( [] );
    const [ has404, setHas404 ] = useState ( [] );
    const { settings } = props;

    useEffect ( () => {
        props.setTitleBar ( "Profile / Favorites" );

        if ( isElectron () ) {
            ipcRenderer.on ( "indexationFinished", getDownloadedIds );
            ipcRenderer.on ( "finishedGetDownloadedIds", storeDownloadedIds );

            ipcRenderer.send ( "getDownloadedItems", "ids" );

        }
        return () => {
            if ( isElectron () ) {
                ipcRenderer.off ( "indexationFinished", getDownloadedIds );
                ipcRenderer.off ( "finishedGetDownloadedIds", storeDownloadedIds );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        if ( isElectron () ) {
            ipcRenderer.send ( "getDownloadedItems", "ids" );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.download.length ] );

    const getDownloadedIds = () => {
        ipcRenderer.send ( "getDownloadedItems", "ids" );
    }

    const storeDownloadedIds = ( event, downloadedItems ) => {
        setDownloadedIds ( downloadedItems.map ( item => item.id ) );
        setHas404 ( downloadedItems.filter ( item => item.is404 === true ).map ( item => item.id ) )
    }

    const createMarkup = ( html ) => {
        return { __html: html }
    }

    const classifyContents = ( results ) => {
        let playlists = [];
        let resources = [];

        // eslint-disable-next-line
        results.map ( ( res ) => {

            if ( res && res.entityBundle === "playlist" ) {
                const playlist = processAsPlaylist ( res );
                playlists.push ( playlist );

            } else if ( res && res.entityBundle === "resource" ) {
                if ( res.fieldResourceFilesByFormat.length > 0 ) {
                    const resource = processAsResource ( res );
                    resource.isDownloading = props.download.map(item => item.resourceId).includes(resource.id);
                    resource.actions.isDownloaded = downloadedIds.includes ( resource.id )
                    resource.is404 = has404.includes ( resource.id );
                    resources.push ( resource )
                }
            }

        } );
        const playlistsFields = [ "title" ];

        let fieldsExcludes = ["filename", "filesize", "entityBundle", "entityChanged", "entityCreated", "description", "tags"];
        if (process.env.REACT_APP_SEE_VERSION !== "1") {
          fieldsExcludes.push("version");
        }

        const resourcesFields = resources[0] ? getFieldsToShow(resources[0].metadata, fieldsExcludes) : playlistsFields;

        return { playlists, playlistsFields, resources, resourcesFields };
    }

    const { loading, error, data } = useQuery ( FAVORITES_QUERY,
        {
            notifyOnNetworkStatusChange: true,
            returnPartialData: true,
            partialRefetch: true,
            errorPolicy: "ignore"
        } )

    if ( loading ) {
        return (
            <StyledDiv>
                <Loader
                    message="Loading"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            </StyledDiv>
        )
    }

    if ( error ) {
        return (
            <StyledDiv>
                <div>
                    <h1>No data recovered</h1>
                </div>
            </StyledDiv>
        )
    }

    const results = data.currentUserFavouriteContent[0]
    const { playlists, playlistsFields, resources, resourcesFields } = classifyContents ( results ) || [];

    if ( !data || Object.keys ( data ).length === 0 ) {
        return null
    }

    return (
        <StyledDiv>
            <div className={ "FavoritesSection" }>
                {
                    settings.playlistsFirst &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Playlists"
                        fieldsToShow={ playlistsFields }
                        data={ playlists }
                        type={ "favorites_playlist_first" }
                        tableUnified={false}
                    />
                }
                <ResultTable
                    rowWidth={ 80 }
                    title="Resources"
                    fieldsToShow={ resourcesFields }
                    data={ resources }
                    type={ "favorites_resource" }
                    tableUnified={false}
                />
                {
                    !settings.playlistsFirst &&
                    <ResultTable
                        rowWidth={ 80 }
                        title="Playlists"
                        fieldsToShow={ playlistsFields }
                        data={ playlists }
                        type={ "favorites_playlist_last" }
                        tableUnified={false}
                    />
                }

            </div>
            {
                props.dialogVisible &&
                <Dialog/>
            }
            <Modal show={ props.visibleModalBokecc }
                   onHide={ props.hideModalBokecc }
                   size="lg"
                   backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{ props.modalTitle }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StyledModalBody dangerouslySetInnerHTML={ createMarkup ( props.modalBody ) }/>
                </Modal.Body>
            </Modal>
        </StyledDiv>
    )
}

const mapStateToProps = ( state ) => ( {
    loadedPlaylist: state.playlist,
    loadedResource: state.resource,
    session: state.session,
    settings: state.settings,
    download: state.download.download,
    visibleModalBokecc: state.ui.visibleModalBokecc,
    dialogVisible: state.ui.dialogVisible,
    modalTitle: state.ui.modalTitle,
    modalBody: state.ui.modalBody,
} );

export default connect ( mapStateToProps, {
    showModalBokecc,
    hideModalBokecc,
    setTitleBar,
} ) ( FavoritesSection );
